import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/verify-otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route
          path="/BirthdayNotifications"
          element={<Pages.BirthdayNotifications startDate={""} endDate={""} />}
        />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route
          path="/manage-users/detail/:id"
          element={<Pages.ManageUserDetail />}
        />
        <Route path="/manage-users/edit/:id" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route
          path="/manage-subadmin/edit/:id"
          element={<Pages.AddSubadmin />}
        />
        <Route
          path="/manage-subadmin/detail/:id"
          element={<Pages.SubadminDetail />}
        />
        <Route
          path="/manage-subadmin/roles"
          element={<Pages.ManageSubadminRoles />}
        />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route
          path="/manage-subadmin/roles/edit/:id"
          element={<Pages.AddRole />}
        />
        <Route
          path="/manage-subadmin/roles/detail/:id"
          element={<Pages.RoleDetail />}
        />

        <Route
          path="/manage-notifications"
          element={<Pages.ManageNotifications />}
        />
        <Route
          path="/manage-notifications/add"
          element={<Pages.AddNotification />}
        />
        <Route
          path="/manage-notifications/detail/:id"
          element={<Pages.NotificationDetail />}
        />
        <Route
          path="/recieved-notifications"
          element={<Pages.RecievedNotifications />}
        />
        <Route
          path="/manage-email-template"
          element={<Pages.ManageSystemSettings />}
        />
        <Route
          path="/manage-email-template/add-email-template"
          element={<Pages.AddEmailTemplate />}
        />
        <Route
          path="/manage-email-template/edit-email-template/:id"
          element={<Pages.AddEmailTemplate />}
        />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route
          path="/manage-profile/change-password"
          element={<Pages.ChangePassword />}
        />

        <Route path="/manage-promotions" element={<Pages.ManagePromotion />} />
        <Route path="/manage-promotions/add" element={<Pages.AddPromotion />} />
        <Route
          path="/manage-promotions/edit/:id"
          element={<Pages.AddPromotion />}
        />
        <Route
          path="/manage-promotions/view/:id"
          element={<Pages.ViewPromotion />}
        />
        <Route path="/manage-stores" element={<Pages.ManageStores />} />
        <Route path="/manage-stores/add" element={<Pages.AddStore />} />
        <Route path="/manage-stores/edit/:id" element={<Pages.AddStore />} />
        <Route
          path="/manage-stores/detail/:id"
          element={<Pages.StoreDetail />}
        />
        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route path="/manage-rewards" element={<Pages.ManageRewards />} />
        <Route path="/manage-rewards/add" element={<Pages.AddRewards />} />
        <Route path="/manage-rewards/edit/:id" element={<Pages.AddRewards />} />
        <Route
          path="/manage-rewards/detail/:id"
          element={<Pages.RewardsDetail />}
        />
        <Route
          path="/manage-transactions"
          element={<Pages.ManageTransction />}
        />
        <Route
          path="/manage-transactions/view"
          element={<Pages.ViewTransction />}
        />
        <Route
          path="/manage-activity-logs"
          element={<Pages.ManageActivityLogs />}
        />
        <Route
          path="/manage-feedback-and-reports"
          element={<Pages.ManageFeedbackReports />}
        />
        <Route path="/permission-denied" element={<Pages.PermissionDenied />} />
      </Route>
    </Routes>
  );
};

export default Routing;
